import ReleaseOne from "../mockData/images/releases/1.jpg"
import ReleaseTwo from "../mockData/images/releases/2.jpg"
import ReleaseThree from "../mockData/images/releases/3.jpg"
import ReleaseFour from "../mockData/images/releases/4.jpg"
import ReleaseFive from "../mockData/images/releases/5.jpg"
import ReleaseSix from "../mockData/images/releases/6.jpg"
import ReleaseSeven from "../mockData/images/releases/7.jpg"
import ReleaseEight from "../mockData/images/releases/8.jpg"
import ReleaseNine from "../mockData/images/releases/9.jpg"
import ReleaseTen from "../mockData/images/releases/10.jpg"
import ReleaseEleven from "../mockData/images/releases/11.jpg"
import ReleaseTwelve from "../mockData/images/releases/12.jpg"
import ReleaseThirteen from "../mockData/images/releases/13.jpg"
import ReleaseFourteen from "../mockData/images/releases/14.jpg"
import ReleaseFifteen from "../mockData/images/releases/15.jpg"
import ReleaseSixteen from "../mockData/images/releases/16.jpg"
import ReleaseSeventeen from "../mockData/images/releases/17.jpg"
import ReleaseEighteen from "../mockData/images/releases/18.jpg"
import ReleaseNineteen from "../mockData/images/releases/19.jpg"
import ReleaseTwenty from "../mockData/images/releases/20.jpg"
import ReleaseTwentyOne from "../mockData/images/releases/21.jpg"
import ReleaseTwentyTwo from "../mockData/images/releases/22.jpg"
import ReleaseTwentyThree from "../mockData/images/releases/23.jpg"
import ReleaseTwentyFour from "../mockData/images/releases/24.jpg"
import ReleaseTwentyFive from "../mockData/images/releases/25.jpg"
import ReleaseTwentySix from "../mockData/images/releases/26.jpg"
import ReleaseTwentySeven from "../mockData/images/releases/27.jpg"
import ReleaseTwentyEight from "../mockData/images/releases/28.jpg"
import ReleaseTwentyNine from "../mockData/images/releases/29.jpg"

const mockReleaseData = [
    {
        "id": 1,
        "name": "Echoing Silhouette",
        "created": "2023-12-21T10:23:19.235919Z",
        "label": "Bassline Bridge Studios",
        "artwork": ReleaseOne,
        "is_new_release": 0,
        "catalogue_number": "IFO942591",
        "get_artists": "Gideon Bass",
        "status": "distributed",
        "ean": "4251164864328",
        "official_date": "2023-10-13",
        "original_date": "2023-10-13",
        "exclusive_date": null,
        "get_mixes_number": 1,
        "all_tracks_ready": true,
        "store_urls": [
            {
                "url": "https://music.amazon.com/albums/B0B87XMM2K",
                "store_name": "amazon-music"
            },
            {
                "url": "https://music.apple.com/us/album/blow-to-the-heart-single/1541924131",
                "store_name": "apple-music"
            },
            {
                "url": "https://www.beatport.com/release/release/3208499",
                "store_name": "beatport"
            },
            {
                "url": "https://www.deezer.com/album/188436372",
                "store_name": "deezer"
            },
            {
                "url": "https://www.junodownload.com/products/deborah-de-luca-blow-to-the-heart/4860483-02/",
                "store_name": "junodownload"
            },
            {
                "url": "https://open.spotify.com/album/1IT0Ooet0ZjYdNMZi7u9kr",
                "store_name": "spotify"
            },
            {
                "url": "https://store.tidal.com/ch/album/163265302",
                "store_name": "tidal"
            },
            {
                "url": "http://www.traxsource.com/title/1478446/Blow-To-The-Heart",
                "store_name": "traxsource"
            },
            {
                "url": "https://music.youtube.com/playlist?list=OLAK5uy_kJB9gikI5jPMpRJFZFivL8dTFveYK8Z2o&feature=share",
                "store_name": "youtube-music"
            }
        ],        
        "release_date_passed": true,
        "has_delivery_confirmations": false,
        "qc_passed": true,
        "qc_feedback": {},
        "edited_after_qc": false
    },
    {
        "id": 2,
        "name": "Serene Legacy",
        "created": "2023-12-21T10:18:01.502185Z",
        "label": "Bassline Bridge Studios",
        "artwork": ReleaseTwo,
        "is_new_release": 0,
        "catalogue_number": "RMT816746",
        "get_artists": "Silas Echo",
        "status": "distributed",
        "ean": "4251164855203",
        "official_date": "2023-11-25",
        "original_date": "2023-11-25",
        "exclusive_date": null,
        "get_mixes_number": 1,
        "all_tracks_ready": true,
        "store_urls": [
            {
                "url": "https://music.amazon.com/albums/B0B87XMM2K",
                "store_name": "amazon-music"
            },
            {
                "url": "https://music.apple.com/us/album/blow-to-the-heart-single/1541924131",
                "store_name": "apple-music"
            },
            {
                "url": "https://www.beatport.com/release/release/3208499",
                "store_name": "beatport"
            },
            {
                "url": "https://www.deezer.com/album/188436372",
                "store_name": "deezer"
            },
            {
                "url": "https://www.junodownload.com/products/deborah-de-luca-blow-to-the-heart/4860483-02/",
                "store_name": "junodownload"
            },
            {
                "url": "https://open.spotify.com/album/1IT0Ooet0ZjYdNMZi7u9kr",
                "store_name": "spotify"
            },
            {
                "url": "https://store.tidal.com/ch/album/163265302",
                "store_name": "tidal"
            },
            {
                "url": "http://www.traxsource.com/title/1478446/Blow-To-The-Heart",
                "store_name": "traxsource"
            },
            {
                "url": "https://music.youtube.com/playlist?list=OLAK5uy_kJB9gikI5jPMpRJFZFivL8dTFveYK8Z2o&feature=share",
                "store_name": "youtube-music"
            }
        ],        
        "release_date_passed": true,
        "has_delivery_confirmations": false,
        "qc_passed": true,
        "qc_feedback": {},
        "edited_after_qc": false
    },
    {
        "id": 3,
        "name": "Mystic Voyage",
        "created": "2023-12-21T09:57:01.117224Z",
        "label": "Harmonic Fusion Records",
        "artwork": ReleaseThree,
        "is_new_release": 0,
        "catalogue_number": "CTQ011348",
        "get_artists": "Iris Fugue",
        "status": "distributed",
        "ean": "4251164863802",
        "official_date": "2023-10-14",
        "original_date": "2023-10-14",
        "exclusive_date": null,
        "get_mixes_number": 2,
        "all_tracks_ready": true,
        "store_urls": [
            {
                "url": "https://music.amazon.com/albums/B0B87XMM2K",
                "store_name": "amazon-music"
            },
            {
                "url": "https://music.apple.com/us/album/blow-to-the-heart-single/1541924131",
                "store_name": "apple-music"
            },
            {
                "url": "https://www.beatport.com/release/release/3208499",
                "store_name": "beatport"
            },
            {
                "url": "https://www.deezer.com/album/188436372",
                "store_name": "deezer"
            },
            {
                "url": "https://www.junodownload.com/products/deborah-de-luca-blow-to-the-heart/4860483-02/",
                "store_name": "junodownload"
            },
            {
                "url": "https://open.spotify.com/album/1IT0Ooet0ZjYdNMZi7u9kr",
                "store_name": "spotify"
            },
            {
                "url": "https://store.tidal.com/ch/album/163265302",
                "store_name": "tidal"
            },
            {
                "url": "http://www.traxsource.com/title/1478446/Blow-To-The-Heart",
                "store_name": "traxsource"
            },
            {
                "url": "https://music.youtube.com/playlist?list=OLAK5uy_kJB9gikI5jPMpRJFZFivL8dTFveYK8Z2o&feature=share",
                "store_name": "youtube-music"
            }
        ],        
        "release_date_passed": true,
        "has_delivery_confirmations": false,
        "qc_passed": true,
        "qc_feedback": {},
        "edited_after_qc": false
    },
    {
        "id": 4,
        "name": "Rising Rhapsody",
        "created": "2023-12-21T09:30:52.871582Z",
        "label": "Harmonic Fusion Records",
        "artwork": ReleaseFour,
        "is_new_release": 0,
        "catalogue_number": "JXC609445",
        "get_artists": "Nadia Tune",
        "status": "distributed",
        "ean": "4251164851830",
        "official_date": "2023-11-26",
        "original_date": "2023-11-26",
        "exclusive_date": null,
        "get_mixes_number": 2,
        "all_tracks_ready": true,
        "store_urls": [
            {
                "url": "https://music.amazon.com/albums/B0B87XMM2K",
                "store_name": "amazon-music"
            },
            {
                "url": "https://music.apple.com/us/album/blow-to-the-heart-single/1541924131",
                "store_name": "apple-music"
            },
            {
                "url": "https://www.beatport.com/release/release/3208499",
                "store_name": "beatport"
            },
            {
                "url": "https://www.deezer.com/album/188436372",
                "store_name": "deezer"
            },
            {
                "url": "https://www.junodownload.com/products/deborah-de-luca-blow-to-the-heart/4860483-02/",
                "store_name": "junodownload"
            },
            {
                "url": "https://open.spotify.com/album/1IT0Ooet0ZjYdNMZi7u9kr",
                "store_name": "spotify"
            },
            {
                "url": "https://store.tidal.com/ch/album/163265302",
                "store_name": "tidal"
            },
            {
                "url": "http://www.traxsource.com/title/1478446/Blow-To-The-Heart",
                "store_name": "traxsource"
            },
            {
                "url": "https://music.youtube.com/playlist?list=OLAK5uy_kJB9gikI5jPMpRJFZFivL8dTFveYK8Z2o&feature=share",
                "store_name": "youtube-music"
            }
        ],
        "release_date_passed": true,
        "has_delivery_confirmations": false,
        "qc_passed": true,
        "qc_feedback": {},
        "edited_after_qc": false
    },
    {
        "id": 5,
        "name": "Echoing Paradise",
        "created": "2023-12-21T09:21:17.865009Z",
        "label": "Lyrical Landslide Records",
        "artwork": ReleaseFive,
        "is_new_release": 0,
        "catalogue_number": "CDG765204",
        "get_artists": "Piper Requiem",
        "status": "distributed",
        "ean": "4251164866087",
        "official_date": "2023-10-27",
        "original_date": "2023-10-27",
        "exclusive_date": null,
        "get_mixes_number": 2,
        "all_tracks_ready": true,
        "store_urls": [
            {
                "url": "https://music.amazon.com/albums/B0B87XMM2K",
                "store_name": "amazon-music"
            },
            {
                "url": "https://music.apple.com/us/album/blow-to-the-heart-single/1541924131",
                "store_name": "apple-music"
            },
            {
                "url": "https://www.beatport.com/release/release/3208499",
                "store_name": "beatport"
            },
            {
                "url": "https://www.deezer.com/album/188436372",
                "store_name": "deezer"
            },
            {
                "url": "https://www.junodownload.com/products/deborah-de-luca-blow-to-the-heart/4860483-02/",
                "store_name": "junodownload"
            },
            {
                "url": "https://open.spotify.com/album/1IT0Ooet0ZjYdNMZi7u9kr",
                "store_name": "spotify"
            },
            {
                "url": "https://store.tidal.com/ch/album/163265302",
                "store_name": "tidal"
            },
            {
                "url": "http://www.traxsource.com/title/1478446/Blow-To-The-Heart",
                "store_name": "traxsource"
            },
            {
                "url": "https://music.youtube.com/playlist?list=OLAK5uy_kJB9gikI5jPMpRJFZFivL8dTFveYK8Z2o&feature=share",
                "store_name": "youtube-music"
            }
        ],
        "release_date_passed": true,
        "has_delivery_confirmations": false,
        "qc_passed": true,
        "qc_feedback": {},
        "edited_after_qc": false
    },
    {
        "id": 6,
        "name": "Harmonic Odyssey",
        "created": "2023-09-22T13:29:03.552787Z",
        "label": "Lyrical Landslide Records",
        "artwork": ReleaseSix,
        "is_new_release": 1,
        "catalogue_number": "LKH302908",
        "get_artists": "Nyx Harmony",
        "status": "offline",
        "ean": "",
        "official_date": "2023-06-26",
        "original_date": "2023-06-26",
        "exclusive_date": null,
        "get_mixes_number": 1,
        "all_tracks_ready": true,
        "store_urls": [],
        "release_date_passed": true,
        "has_delivery_confirmations": false,
        "qc_passed": false,
        "qc_feedback": {
            "results": {
                "track_level": {
                    "1325": {
                        "main_genre": [
                            "The Main Genre can not be same as the Sub Genre."
                        ],
                        "p_line_year": [
                            "Copyright P year must match the Original Release date Year. This field can not be in future or in future relative to the original release date."
                        ],
                        "main_subgenre": [
                            "The Sub Genre can not be the same as the Main Genre."
                        ]
                    }
                },
                "release_level": {
                    "name": [
                        "Please don't insert feat, featuring, feat. featuring., with. in the release name, as that will be manually added by the stores."
                    ],
                    "main_genre": [
                        "Main Genre can not be same as the Sub Genre."
                    ],
                    "c_line_year": [
                        "Copyright P year must match the Original Release date Year. This field can not be in future or in future relative to the original release date."
                    ],
                    "p_line_year": [
                        "Copyright P year must match the Original Release date Year. This field can not be in future or in future relative to the original release date."
                    ],
                    "main_subgenre": [
                        "Sub Genre can not be the same as the Main Genre."
                    ]
                }
            }
        },
        "edited_after_qc": true
    },
    {
        "id": 7,
        "name": "Harmonic Rhapsody",
        "created": "2023-09-25T09:44:52.142967Z",
        "label": "Lyrical Landslide Records",
        "artwork": ReleaseSeven,
        "is_new_release": 1,
        "catalogue_number": "FVF924096",
        "get_artists": "Luna Spectre",
        "status": "ready",
        "ean": "",
        "official_date": "2023-06-26",
        "original_date": "2023-06-26",
        "exclusive_date": null,
        "get_mixes_number": 1,
        "all_tracks_ready": true,
        "store_urls": [],
        "release_date_passed": true,
        "has_delivery_confirmations": false,
        "qc_passed": false,
        "qc_feedback": {
            "results": {
                "track_level": {
                    "1331": {
                        "track_version": [
                            "Standalone 'Remix' or 'Mix' is not allowed. Please specify the Mix Name (e.g., 'Remix 2023' or 'Antonio Dj Remix') and re-submit."
                        ]
                    }
                },
                "release_level": {
                    "release_version": [
                        "Standalone 'Remix' or 'Mix' is not allowed. Please specify proper Release Version (e.g., 'Remix 2023' or 'Antonio Dj Remix') and re-submit."
                    ]
                }
            }
        },
        "edited_after_qc": false
    },
    {
        "id": 8,
        "name": "Rising Silhouette",
        "created": "2023-09-22T14:15:05.784642Z",
        "label": "Lyrical Landslide Records",
        "artwork": ReleaseEight,
        "is_new_release": 1,
        "catalogue_number": "AUR535236",
        "get_artists": "Ivy Nocturne",
        "status": "offline",
        "ean": "",
        "official_date": "2023-10-13",
        "original_date": "2023-10-13",
        "exclusive_date": null,
        "get_mixes_number": 1,
        "all_tracks_ready": true,
        "store_urls": [],
        "release_date_passed": true,
        "has_delivery_confirmations": false,
        "qc_passed": false,
        "qc_feedback": {
            "results": {
                "track_level": {
                    "1327": {
                        "track_version": [
                            "Standalone 'Remix' or 'Mix' is not allowed. Please specify the Mix Name (e.g., 'Remix 2023' or 'Antonio Dj Remix') and re-submit."
                        ]
                    }
                },
                "release_level": {
                    "release_version": [
                        "Your release consists of only one track which is not an Original Mix, therefore the custom track mix name must be inserted in the Release Version.",
                        "Standalone 'Remix' or 'Mix' is not allowed. Please specify proper Release Version (e.g., 'Remix 2023' or 'Antonio Dj Remix') and re-submit."
                    ]
                }
            }
        },
        "edited_after_qc": false
    },
    {
        "id": 9,
        "name": "Echoing Harmony",
        "created": "2023-11-03T15:25:50.592628Z",
        "label": "Midnight Melodies Co.",
        "artwork": ReleaseNine,
        "is_new_release": 0,
        "catalogue_number": "JEI857088",
        "get_artists": "Vox Aria",
        "status": "offline",
        "ean": "00602458641578",
        "official_date": "2023-10-13",
        "original_date": "2023-10-13",
        "exclusive_date": null,
        "get_mixes_number": 1,
        "all_tracks_ready": null,
        "store_urls": [],
        "release_date_passed": true,
        "has_delivery_confirmations": false,
        "qc_passed": false,
        "qc_feedback": {},
        "edited_after_qc": false
    },
    {
        "id": 10,
        "name": "Melodic Harmony",
        "created": "2023-08-21T07:50:21.690368Z",
        "label": "Midnight Melodies Co.",
        "artwork": ReleaseTen,
        "is_new_release": 1,
        "catalogue_number": "SKQ769718",
        "get_artists": "Aster Veldt",
        "status": "approval",
        "ean": "",
        "official_date": "2023-09-21",
        "original_date": "2023-09-21",
        "exclusive_date": null,
        "get_mixes_number": 2,
        "all_tracks_ready": true,
        "store_urls": [],
        "release_date_passed": true,
        "has_delivery_confirmations": false,
        "qc_passed": true,
        "qc_feedback": {},
        "edited_after_qc": false
    },
    {
        "id": 11,
        "name": "Rising Harmony",
        "created": "2023-08-15T15:05:56.750101Z",
        "label": "Midnight Melodies Co.",
        "artwork": ReleaseEleven,
        "is_new_release": 1,
        "catalogue_number": "DRN022100",
        "get_artists": "Felix Lyric",
        "status": "locked",
        "ean": "4251164827002",
        "official_date": "2023-09-14",
        "original_date": "2023-09-14",
        "exclusive_date": null,
        "get_mixes_number": 1,
        "all_tracks_ready": true,
        "store_urls": [],
        "release_date_passed": true,
        "has_delivery_confirmations": false,
        "qc_passed": true,
        "qc_feedback": {},
        "edited_after_qc": false
    },
    {
        "id": 12,
        "name": "Whispering Rhapsody",
        "created": "2023-08-17T10:53:43.567072Z",
        "label": "Midnight Melodies Co.",
        "artwork": ReleaseTwelve,
        "is_new_release": 1,
        "catalogue_number": "YXR318561",
        "get_artists": "Cleo Harmonix",
        "status": "ready",
        "ean": "",
        "official_date": "2023-09-14",
        "original_date": "2023-09-14",
        "exclusive_date": null,
        "get_mixes_number": 1,
        "all_tracks_ready": true,
        "store_urls": [],
        "release_date_passed": true,
        "has_delivery_confirmations": false,
        "qc_passed": false,
        "qc_feedback": {
            "results": {
                "track_level": {
                    "1292": {}
                },
                "release_level": {
                    "release_version": [
                        "Your release consists of only one track which is not an Original Mix, therefore the custom track mix name must be inserted in the Release Version."
                    ]
                }
            }
        },
        "edited_after_qc": true
    },
    {
        "id": 13,
        "name": "Eternal Echo",
        "created": "2023-08-15T15:09:38.802218Z",
        "label": "Orbitwave Audio",
        "artwork": ReleaseThirteen,
        "is_new_release": 1,
        "catalogue_number": "UDT099515",
        "get_artists": "Lyra Chord",
        "status": "approval",
        "ean": "",
        "official_date": "2023-09-14",
        "original_date": "2023-09-14",
        "exclusive_date": null,
        "get_mixes_number": 1,
        "all_tracks_ready": true,
        "store_urls": [],
        "release_date_passed": true,
        "has_delivery_confirmations": false,
        "qc_passed": true,
        "qc_feedback": {},
        "edited_after_qc": false
    },
    {
        "id": 14,
        "name": "Radiant Silhouette",
        "created": "2023-08-16T12:31:42.384985Z",
        "label": "Orbitwave Audio",
        "artwork": ReleaseFourteen,
        "is_new_release": 0,
        "catalogue_number": "VJB969676",
        "get_artists": "Riven Solara",
        "status": "approval",
        "ean": "",
        "official_date": "2023-08-31",
        "original_date": "2023-08-31",
        "exclusive_date": null,
        "get_mixes_number": 1,
        "all_tracks_ready": true,
        "store_urls": [],
        "release_date_passed": true,
        "has_delivery_confirmations": false,
        "qc_passed": false,
        "qc_feedback": {
            "results": {
                "track_level": {
                    "1289": {
                        "artists": [
                            "Not all Artists (Main and/or Featuring) on Release and track level are matching. In the case of one-song releases, your Main Artists and Featuring Artists (if you have them) must match on both Release and Track Levels."
                        ]
                    }
                },
                "release_level": {
                    "artists": [
                        "There can be a maximum of 4 artists on a Release level in total (Main). Please add Various Artists as release main artists on a Release level."
                    ]
                }
            }
        },
        "edited_after_qc": false
    },
    {
        "id": 15,
        "name": "Radiant Symphony",
        "created": "2023-08-17T11:01:04.255263Z",
        "label": "Orbitwave Audio",
        "artwork": ReleaseFifteen,
        "is_new_release": 0,
        "catalogue_number": "CBM504564",
        "get_artists": "Mira Celestia",
        "status": "re_delivery-editing",
        "ean": "",
        "official_date": "2023-08-31",
        "original_date": "2023-08-10",
        "exclusive_date": null,
        "get_mixes_number": 2,
        "all_tracks_ready": true,
        "store_urls": [],
        "release_date_passed": true,
        "has_delivery_confirmations": false,
        "qc_passed": true,
        "qc_feedback": {},
        "edited_after_qc": true
    },
    {
        "id": 16,
        "name": "Serene Odyssey",
        "created": "2023-08-15T10:55:42.764448Z",
        "label": "Orbitwave Audio",
        "artwork": ReleaseSixteen,
        "is_new_release": 0,
        "catalogue_number": "JKK500785",
        "get_artists": "Kai Tempo",
        "status": "ready",
        "ean": "",
        "official_date": "2023-08-15",
        "original_date": "2023-06-14",
        "exclusive_date": null,
        "get_mixes_number": 1,
        "all_tracks_ready": true,
        "store_urls": [],
        "release_date_passed": true,
        "has_delivery_confirmations": false,
        "qc_passed": false,
        "qc_feedback": {
            "results": {
                "track_level": {
                    "1285": {
                        "main_genre": [
                            "The Main Genre can not be same as the Sub Genre."
                        ],
                        "main_subgenre": [
                            "The Sub Genre can not be the same as the Main Genre."
                        ]
                    }
                },
                "release_level": {
                    "main_genre": [
                        "Main Genre can not be same as the Sub Genre."
                    ],
                    "main_subgenre": [
                        "Sub Genre can not be the same as the Main Genre."
                    ]
                }
            }
        },
        "edited_after_qc": false
    },
    {
        "id": 17,
        "name": "Eternal Rhapsody",
        "created": "2023-08-16T12:28:09.890730Z",
        "label": "Pulsepoint Productions",
        "artwork": ReleaseSeventeen,
        "is_new_release": 0,
        "catalogue_number": "WNR697895",
        "get_artists": "Zane Melody",
        "status": "offline",
        "ean": "",
        "official_date": "2023-08-14",
        "original_date": "2023-08-14",
        "exclusive_date": null,
        "get_mixes_number": 1,
        "all_tracks_ready": true,
        "store_urls": [],
        "release_date_passed": true,
        "has_delivery_confirmations": false,
        "qc_passed": true,
        "qc_feedback": {},
        "edited_after_qc": false
    },
    {
        "id": 18,
        "name": "Radiant Silhouette",
        "created": "2023-08-15T10:48:58.908022Z",
        "label": "Pulsepoint Productions",
        "artwork": ReleaseEighteen,
        "is_new_release": 0,
        "catalogue_number": "FPR113667",
        "get_artists": "Bella Adagio",
        "status": "offline",
        "ean": "",
        "official_date": "2023-08-10",
        "original_date": "2023-08-08",
        "exclusive_date": null,
        "get_mixes_number": 1,
        "all_tracks_ready": null,
        "store_urls": [],
        "release_date_passed": true,
        "has_delivery_confirmations": false,
        "qc_passed": false,
        "qc_feedback": {
            "results": {
                "track_level": {
                    "1284": {
                        "artists": [
                            "Missing at least one Main Artist on the track.",
                            "Not all Artists (Main and/or Featuring) on Release and track level are matching. In the case of one-song releases, your Main Artists and Featuring Artists (if you have them) must match on both Release and Track Levels."
                        ],
                        "language": [
                            "Please assign Track Language."
                        ],
                        "isrc_code": [
                            "Missing ISRC code, please either add your own, or mark 'Generate ISRC' checkbox."
                        ],
                        "main_genre": [
                            "Missing The Main Genre. Please insert it and re-submit."
                        ],
                        "publishers": [
                            "Missing Publisher, please insert the publishing company for the Author/Songwriter or insert Copyright Control if you do not have a Publishing company.",
                            "Missing Author/Songwriter Full Name (full first and last name). Please insert it and re-submit."
                        ],
                        "p_line_text": [
                            "Please assign the Copyright P Holder."
                        ],
                        "p_line_year": [
                            "Please assign the Copyright P Year."
                        ],
                        "audio_locale": [
                            "Missing Vocals declaration on Track level, please insert it and re-submit."
                        ],
                        "contributors": [
                            "Missing Composer role with its Full Name (first and last name) in the Contributors. At least one person must be assigned as a Composer with its full name."
                        ],
                        "main_subgenre": [
                            "Missing the Sub Genre. Please insert it and re-submit."
                        ]
                    }
                },
                "release_level": {
                    "artists": [
                        "One or more of your Main Artists on the tracks is not present on the Release level. Please add all of your track's Main Artists into the Release level if there are 1 up to 4 Main Artists."
                    ],
                    "language": [
                        "Please assign Language"
                    ],
                    "main_genre": [
                        "Main Genre can not be same as the Sub Genre.",
                        "At least ONE of your tracks must have the same Main Genre as the Release Main Genre."
                    ],
                    "main_subgenre": [
                        "Sub Genre can not be the same as the Main Genre."
                    ]
                }
            }
        },
        "edited_after_qc": false
    },
    {
        "id": 19,
        "name": "Echoing Echo",
        "created": "2023-07-25T09:18:07.421324Z",
        "label": "Retro Rhythms Music",
        "artwork": ReleaseNineteen,
        "is_new_release": 1,
        "catalogue_number": "MOJ860955",
        "get_artists": "Cora Hymn",
        "status": "offline",
        "ean": "4251164863918",
        "official_date": "2023-08-08",
        "original_date": "2023-05-20",
        "exclusive_date": null,
        "get_mixes_number": 3,
        "all_tracks_ready": null,
        "store_urls": [],
        "release_date_passed": true,
        "has_delivery_confirmations": false,
        "qc_passed": false,
        "qc_feedback": {},
        "edited_after_qc": false
    },
    {
        "id": 20,
        "name": "Echoing Rhapsody",
        "created": "2023-08-15T10:35:49.421585Z",
        "label": "Retro Rhythms Music",
        "artwork": ReleaseTwenty,
        "is_new_release": 0,
        "catalogue_number": "XSA660952",
        "get_artists": "Elise Melodia",
        "status": "re_delivery-delivery",
        "ean": "4251164827002",
        "official_date": "2023-08-08",
        "original_date": "2023-08-02",
        "exclusive_date": null,
        "get_mixes_number": 1,
        "all_tracks_ready": true,
        "store_urls": [],
        "release_date_passed": true,
        "has_delivery_confirmations": false,
        "qc_passed": true,
        "qc_feedback": {},
        "edited_after_qc": false
    },
    {
        "id": 21,
        "name": "Echoing Symphony",
        "created": "2023-11-10T11:50:47.397353Z",
        "label": "Retro Rhythms Music",
        "artwork": ReleaseTwentyOne,
        "is_new_release": 0,
        "catalogue_number": "ZOX520125",
        "get_artists": "Jasper Cadenza",
        "status": "offline",
        "ean": "00602458206425",
        "official_date": "2023-07-07",
        "original_date": "2023-07-07",
        "exclusive_date": null,
        "get_mixes_number": 22,
        "all_tracks_ready": null,
        "store_urls": [],
        "release_date_passed": true,
        "has_delivery_confirmations": false,
        "qc_passed": false,
        "qc_feedback": {},
        "edited_after_qc": false
    },
    {
        "id": 22,
        "name": "Echoing Voyage",
        "created": "2023-09-25T09:50:50.297749Z",
        "label": "Retro Rhythms Music",
        "artwork": ReleaseTwentyTwo,
        "is_new_release": 0,
        "catalogue_number": "OPS678622",
        "get_artists": "Vienna Sonata",
        "status": "ready",
        "ean": "4251164863314",
        "official_date": "2023-06-26",
        "original_date": "2023-06-26",
        "exclusive_date": null,
        "get_mixes_number": 1,
        "all_tracks_ready": true,
        "store_urls": [],
        "release_date_passed": true,
        "has_delivery_confirmations": false,
        "qc_passed": false,
        "qc_feedback": {},
        "edited_after_qc": false
    },
    {
        "id": 23,
        "name": "Harmonic Phenomenon",
        "created": "2023-09-20T15:21:24.066424Z",
        "label": "Riff Radiance Music",
        "artwork": ReleaseTwentyThree,
        "is_new_release": 0,
        "catalogue_number": "WLZ315732",
        "get_artists": "Orion Cadence",
        "status": "offline",
        "ean": "4251164862515",
        "official_date": "2023-06-09",
        "original_date": "2023-06-09",
        "exclusive_date": null,
        "get_mixes_number": 1,
        "all_tracks_ready": null,
        "store_urls": [],
        "release_date_passed": true,
        "has_delivery_confirmations": false,
        "qc_passed": false,
        "qc_feedback": {},
        "edited_after_qc": true
    },
    {
        "id": 24,
        "name": "Serene Symphony",
        "created": "2023-09-21T07:19:34.313768Z",
        "label": "Riff Radiance Music",
        "artwork": ReleaseTwentyFour,
        "is_new_release": 0,
        "catalogue_number": "EYR894337",
        "get_artists": "Leo Forte",
        "status": "re_delivery-delivery",
        "ean": "4251164861662",
        "official_date": "2023-05-26",
        "original_date": "2023-05-26",
        "exclusive_date": null,
        "get_mixes_number": 1,
        "all_tracks_ready": true,
        "store_urls": [],
        "release_date_passed": true,
        "has_delivery_confirmations": false,
        "qc_passed": false,
        "qc_feedback": {
            "results": {
                "track_level": {
                    "1321": {}
                },
                "release_level": {
                    "c_line_year": [
                        "Copyright P year must match the Original Release date Year. This field can not be in future or in future relative to the original release date."
                    ]
                }
            }
        },
        "edited_after_qc": false
    },
    {
        "id": 25,
        "name": "Radiant Paradise",
        "created": "2023-09-20T15:26:49.286253Z",
        "label": "Symphony Spectrum Studios",
        "artwork": ReleaseTwentyFive,
        "is_new_release": 0,
        "catalogue_number": "CLY553326",
        "get_artists": "Dante Riff",
        "status": "ready",
        "ean": "4251164862492",
        "official_date": "2023-05-08",
        "original_date": "2023-05-08",
        "exclusive_date": null,
        "get_mixes_number": 1,
        "all_tracks_ready": true,
        "store_urls": [],
        "release_date_passed": true,
        "has_delivery_confirmations": false,
        "qc_passed": false,
        "qc_feedback": {},
        "edited_after_qc": false
    },
    {
        "id": 26,
        "name": "Serene Harmony",
        "created": "2023-09-20T15:31:17.350289Z",
        "label": "Symphony Spectrum Studios",
        "artwork": ReleaseTwentySix,
        "is_new_release": 0,
        "catalogue_number": "NJV468405",
        "get_artists": "Sable Phoenix",
        "status": "ready",
        "ean": "4251164861679",
        "official_date": "2023-04-14",
        "original_date": "2023-04-14",
        "exclusive_date": null,
        "get_mixes_number": 1,
        "all_tracks_ready": true,
        "store_urls": [],
        "release_date_passed": true,
        "has_delivery_confirmations": false,
        "qc_passed": false,
        "qc_feedback": {},
        "edited_after_qc": false
    },
    {
        "id": 27,
        "name": "Echoing Legacy",
        "created": "2023-11-09T12:56:30.840484Z",
        "label": "Vivid Vibes Entertainment",
        "artwork": ReleaseTwentySeven,
        "is_new_release": 0,
        "catalogue_number": "WUY132935",
        "get_artists": "Ezra Vega",
        "status": "offline",
        "ean": "5054197611506",
        "official_date": "2023-03-17",
        "original_date": "2023-03-17",
        "exclusive_date": null,
        "get_mixes_number": 2,
        "all_tracks_ready": null,
        "store_urls": [],
        "release_date_passed": true,
        "has_delivery_confirmations": false,
        "qc_passed": false,
        "qc_feedback": {},
        "edited_after_qc": false
    },
    {
        "id": 28,
        "name": "Vivid Legacy",
        "created": "2023-11-09T09:21:25.047243Z",
        "label": "Vivid Vibes Entertainment",
        "artwork": ReleaseTwentyEight,
        "is_new_release": 0,
        "catalogue_number": "ZYG792321",
        "get_artists": "Nova Wraith",
        "status": "ready",
        "ean": "00602455138736",
        "official_date": "2023-02-25",
        "original_date": "2023-02-25",
        "exclusive_date": null,
        "get_mixes_number": 1,
        "all_tracks_ready": true,
        "store_urls": [],
        "release_date_passed": true,
        "has_delivery_confirmations": false,
        "qc_passed": false,
        "qc_feedback": {},
        "edited_after_qc": false
    },
    {
        "id": 29,
        "name": "Whispering Paradise",
        "created": "2023-09-25T07:28:51.706872Z",
        "label": "Vivid Vibes Entertainment",
        "artwork": ReleaseTwentyNine,
        "is_new_release": 0,
        "catalogue_number": "SQM715022",
        "get_artists": "Cyrus Beat",
        "status": "offline",
        "ean": "4251164860351",
        "official_date": "2023-02-03",
        "original_date": "2023-02-03",
        "exclusive_date": null,
        "get_mixes_number": 1,
        "all_tracks_ready": null,
        "store_urls": [],
        "release_date_passed": true,
        "has_delivery_confirmations": false,
        "qc_passed": false,
        "qc_feedback": {},
        "edited_after_qc": false
    },
];

export default mockReleaseData;